<template>
    <div>
        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">

            <a-form-item label="版本">
                <a-select show-search v-model="searchP.branch" placeholder="输入分支"  allow-clear style="width: 150px">
                    <a-select-option v-for="d in branchList" :key="d.value">
                        {{ d.label }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="handleSubmit">查询</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>

export default {
    components:{
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                branch:'',
            },
            branchList:[]
        }
    },
    methods:{
        getData(){
            let that = this
            let params = {
                urlparams:false
            };
            that.$store.dispatch({
                type: 'branch/getallbranches',
                params:params
            }).then((res)=>{
                that.searchP.branch = '';
                debugger
                if(res.status == 200){
                    that.branchList = res.data
                }
                else{
                    that.branchList = []
                }
                that.handleSubmit();
            })
        },
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        }
      
    },
    mounted(){
        this.getData();
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

